import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import { delay, tap } from 'rxjs/operators';
import { switchMap, first } from "rxjs/operators";

//Firebase
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFirestore, AngularFirestoreDocument } from "angularfire2/firestore";
import * as firebase from "firebase/app"

//Variables
import { environment } from '@env/environment';



@Injectable()
export class AuthAdminService {
   

  constructor(private afAuth: AngularFireAuth,
    private afs: AngularFirestore,){

  }


  async resetPassword(email: string): Promise<void> {
    try{
      return firebase.auth().sendPasswordResetEmail(email);
    } catch(err) {
      console.error("Error al resetear password", err);
      return err;
    }   
  }
  
  async createUser(newName: string, newEmail: string, newPassword: string): Promise<any> {
    /*try{
      firebase.auth().createUser({
        email: newEmail,
        emailVerified: false,
        phoneNumber: null,
        password: newPassword,
        displayName: newName,
        photoURL: "https://goo.gl/7kz9qG",
        disabled: false
      })
        .then(function(user) {
          // See the UserRecord reference doc for the contents of userRecord.
          console.log("Successfully created new user:", user.uid);
          // Send Email Verification,
          //admin.auth().sendEmailVerification(user.uid);
        })
        .catch(function(error) {
          console.log("Error creating new user:", error);
        });
    } catch(err) {      
      console.error("Error al crear usuario", err);
      return err;
    }*/
  } 

  async disabledUser(ref: string, uid: string, state: boolean): Promise<any>{
    try{
      let user = this.updateUserData(ref, uid, {disabled: state});
      return user;
    }catch(error){
      console.error("error disable user", error);
      return error;
    }
  }

  async updateUserData(ref:string, uid: any, data: any) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(
      `${ref}/${uid}`
    );    
    return userRef.set(data, { merge: true });
  }

  async deleteUser(ref: string, uid: any){
    try{
      return await this.afs.collection(ref).doc(uid).delete();
    }catch(error){
      console.error("error delete user", error);
      return error;
    }
  }

}
